export default __webpack_public_path__ + "static/media/banner.d74d4704.svg";